import { GET_GALLERY_DETAILS_BY_ID_SUCCESS } from '../actionTypes/GalleryActionTypes';

export default function suggestedFiltersReducer(state = {}, action) {
    switch (action.type) {
        case GET_GALLERY_DETAILS_BY_ID_SUCCESS: {
            let suggestedFacets = {};
            try {
                suggestedFacets = action.galleryDetails.suggestedFacets;
            } catch (e) {
                /* istanbul ignore next */
                suggestedFacets = action.galleryDetails.suggestedFacets;
            }
            return suggestedFacets;
        }

        default:
            return state;
    }
}
